import { createTheme } from "@mui/material";

export const darkTheme = createTheme({
    typography:{
        fontFamily:[
        'FoundersGroteskWeb', 
        '-apple-system', 
        'BlinkMacSystemFont', 
        'Segoe UI', 
        'Helvetica', 
        'Arial',
        'sans-serif', 
        'Apple Color Emoji', 
        'Segoe UI Emoji', 
        'Segoe UI Symbol',
        ].join(','),
    },
    palette: {
        mode: 'dark'
    }
});
